import { Link } from "react-router-dom";

const HERO =
    "https://static.prod-images.emergentagent.com/jobs/74007a75-e0c2-4452-bdc7-515e3dc56401/images/70e7441c1a3e62fcc7a6c5516de210a28074ce43b82f37c6d661358434e7a3a5.png";

export default function Home() {
    return (
        <div data-testid="home-page">
            {/* HERO */}
            <section
                id="top"
                className="relative pt-24 md:pt-28 pb-12 md:pb-20"
                data-testid="home-hero"
            >
                <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
                    {/* Top meta strip */}
                    <div className="flex flex-wrap items-end justify-end gap-6 mb-8 md:mb-12 rise">
                        <div className="text-right">
                            <p className="font-mono-acc text-[11px] tracking-[0.32em] uppercase text-[var(--muted)] mt-2">
                                generate · innovate · originate · create
                            </p>
                        </div>
                    </div>

                    {/* Headline + Image grid */}
                    <div className="grid grid-cols-12 gap-y-10 md:gap-y-14 md:gap-x-10 items-start">
                        <div className="col-span-12 md:col-span-7 rise rise-d1">
                            <h1 className="font-serif-display text-[14vw] md:text-[10vw] lg:text-[9rem] leading-[0.86] tracking-[-0.03em] text-[var(--ink)]">
                                A room
                                <br />
                                where the
                                <br />
                                <span className="italic text-[var(--sienna)]">
                                    work
                                </span>{" "}
                                lives.
                            </h1>
                        </div>

                        <div className="col-span-12 md:col-span-5 md:pt-6 rise rise-d2">
                            <p className="font-body text-base md:text-lg leading-relaxed text-[var(--ink)]/80 max-w-md">
                                K-Team exists to give creatives a safe space to
                                dream out loud — to develop the work and grow
                                without apology.
                            </p>
                            <div className="mt-8 flex flex-wrap gap-4">
                                <Link
                                    to="/events"
                                    className="btn-edit"
                                    data-testid="home-cta-events"
                                >
                                    Upcoming Event{" "}
                                    <span aria-hidden>→</span>
                                </Link>
                            </div>
                        </div>

                        {/* Hero image — full bleed-ish, with cream border */}
                        <div className="col-span-12 rise rise-d3">
                            <figure className="relative overflow-hidden border border-[var(--ink)]/20 bg-[var(--bg-surface)]">
                                <div className="aspect-[16/9] md:aspect-[21/9] overflow-hidden">
                                    <img
                                        src={HERO}
                                        alt="K-Team studio — vintage paintings, guitars and warm window light"
                                        className="w-full h-full object-cover hero-drift"
                                        data-testid="home-hero-image"
                                    />
                                </div>
                                <figcaption className="flex items-center justify-between gap-4 px-4 md:px-6 py-3 border-t border-[var(--ink)]/20 bg-[var(--bg-paper)]">
                                    <span className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)]">
                                        Fig. 01 — The Long Table, 7:42 AM
                                    </span>
                                    <span className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)] hidden md:inline">
                                        35mm · Kodak Gold · Untouched
                                    </span>
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>

            {/* MARQUEE */}
            <section
                aria-hidden="true"
                className="border-y border-[var(--ink)]/15 py-5 overflow-hidden bg-[var(--bg-paper)]"
            >
                <div className="marquee-track">
                    {Array.from({ length: 2 }).map((_, k) => (
                        <div
                            key={k}
                            className="flex items-center gap-12 pr-12 font-serif-display text-3xl md:text-4xl italic text-[var(--ink)]"
                        >
                            <span>generate</span>
                            <span className="text-[var(--sienna)]">✦</span>
                            <span>innovate</span>
                            <span className="text-[var(--sienna)]">✦</span>
                            <span>originate</span>
                            <span className="text-[var(--sienna)]">✦</span>
                            <span>create</span>
                            <span className="text-[var(--sienna)]">✦</span>
                        </div>
                    ))}
                </div>
            </section>

            {/* MANIFESTO */}
            <section
                id="manifesto"
                className="relative py-24 md:py-40"
                data-testid="home-manifesto"
            >
                <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
                    <div className="grid grid-cols-12 gap-y-12 md:gap-x-10">
                        <div className="col-span-12 md:col-span-3">
                            <p className="font-mono-acc text-[11px] tracking-[0.32em] uppercase text-[var(--sienna)]">
                                § 02 — Manifesto
                            </p>
                            <div className="mt-6 h-px w-16 bg-[var(--ink)]/40" />
                            <p className="mt-6 font-mono-acc text-xs tracking-widest uppercase text-[var(--muted)]">
                                Read aloud, slowly.
                            </p>
                        </div>

                        <div className="col-span-12 md:col-span-9">
                            <p className="font-serif-display text-3xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-[var(--ink)]">
                                K-Team Creative is a company that supports
                                artists in{" "}
                                <span className="italic text-[var(--sienna)]">
                                    making their dreams a reality.
                                </span>{" "}
                                We build community by{" "}
                                <span className="underline decoration-[var(--ochre)] decoration-2 underline-offset-8">
                                    connecting artists to their audience.
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FEATURED EVENT TEASER */}
            <section
                id="featured"
                className="relative py-20 md:py-32 bg-[var(--ink)] text-[var(--bg-base)] overflow-hidden"
                data-testid="home-featured-event"
            >
                <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
                    <div className="grid grid-cols-12 gap-y-10 md:gap-x-10 items-end">
                        <div className="col-span-12 md:col-span-7">
                            <p className="font-mono-acc text-[11px] tracking-[0.32em] uppercase text-[var(--ochre)]">
                                § 03 — Now Booking
                            </p>
                            <h2 className="mt-6 font-serif-display text-5xl md:text-7xl lg:text-8xl leading-[0.92] tracking-[-0.02em]">
                                Record Release{" "}
                                <span className="italic">Flytrap</span>.
                                <br />
                                An album,
                                <br />a room,{" "}
                                <span className="text-[var(--ochre)]">
                                    one night.
                                </span>
                            </h2>
                        </div>
                        <div className="col-span-12 md:col-span-5 md:pl-8">
                            <div className="border border-[var(--bg-base)]/30 p-6 md:p-8">
                                <div className="flex items-start justify-between gap-6">
                                    <div>
                                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)]/55">
                                            Date
                                        </p>
                                        <p className="font-serif-display text-4xl md:text-5xl mt-2 leading-none">
                                            JUN 21
                                        </p>
                                        <p className="font-mono-acc text-xs tracking-[0.32em] uppercase mt-2">
                                            Sunday — 20:00 → late
                                        </p>
                                    </div>
                                    <div className="text-right">
                                        <p className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--bg-base)]/55">
                                            Venue
                                        </p>
                                        <p className="font-body text-sm mt-2">
                                            Sweet Loretta Bar
                                        </p>
                                    </div>
                                </div>
                                <div className="my-6 h-px bg-[var(--bg-base)]/20" />
                                <p className="font-body text-sm leading-relaxed text-[var(--bg-base)]/85">
                                    <span className="italic">Flytrap</span>{" "}
                                    unveils{" "}
                                    <span className="italic">
                                        Weapons of Mass Creation
                                    </span>{" "}
                                    — one room, one record, one long night of
                                    feedback, friends and the smell of wet
                                    paint.
                                </p>
                                <div className="mt-8">
                                    <Link
                                        to="/events"
                                        data-testid="home-featured-cta"
                                        className="btn-edit"
                                        style={{
                                            borderColor: "var(--bg-base)",
                                            color: "var(--bg-base)",
                                        }}
                                    >
                                        See the ticket →
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
